import type { PlatformAdapters } from '@hoedokloop/platform-ports';
import { createContext, type ReactNode, useContext } from 'react';

const PlatformContext = createContext<PlatformAdapters | undefined>(undefined);

export function PlatformProvider({
  adapters,
  children,
}: {
  adapters: PlatformAdapters;
  children: ReactNode;
}) {
  return <PlatformContext.Provider value={adapters}>{children}</PlatformContext.Provider>;
}

export function usePlatform(): PlatformAdapters {
  const value = useContext(PlatformContext);
  if (!value) throw new Error('PlatformProvider is required');
  return value;
}
